import { Box, Button, Typography } from "@mui/material";
import { baseWebUrl } from "lib/constants";
import { QRList } from "lib/features/qrList/types";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { myQRListStyles } from "styles/QRListDirectory/myqrList.styles";
import QRCodeContainer from "../QRCodeContainer";

interface QRDetailsProps {
  userId: number;
  qrcode: QRList;
}

const QRDetails = ({ userId, qrcode }: QRDetailsProps) => {
  const navigate = useNavigate();
  const qrCodeRef = useRef<HTMLDivElement>(null);

  const link = qrcode?.business_list?.id
    ? `${baseWebUrl}/business/checkout/${qrcode?.business_list?.id}`
    : `No list assosiated`;

  const handleExportQR = () => {
    if (!qrCodeRef.current) return;

    const svgElement = qrCodeRef.current.querySelector("svg");
    if (!svgElement) return;

    const svgData = new XMLSerializer().serializeToString(svgElement);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    const padding = 20;

    img.onload = () => {
      canvas.width = img.width + padding * 2;
      canvas.height = img.height + padding * 2;

      ctx!.fillStyle = "white";
      ctx!.fillRect(0, 0, canvas.width, canvas.height);

      ctx!.drawImage(img, padding, padding);

      const pngFile = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.download = `${qrcode.qr_name || "qr_code"}.png`;
      downloadLink.href = pngFile;
      downloadLink.click();
    };

    img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgData)}`;
  };

  return (
    <Box sx={myQRListStyles.qrDetailsContainer}>
      {/* QR Container */}
      <Box sx={myQRListStyles.qrContainer}>
        <QRCodeContainer link={link} ref={qrCodeRef} />
      </Box>

      {/* QR Details */}
      <Box sx={myQRListStyles.qrDetails}>
        <Typography sx={myQRListStyles.mainHeading}>
          {qrcode.qr_name}
        </Typography>
        <Typography sx={myQRListStyles.subHeading}>
          List: {qrcode?.business_list?.list_name ?? "Not assigned yet"}
        </Typography>
        <Button
          variant="outlined"
          sx={myQRListStyles.actionButton}
          onClick={handleExportQR}
        >
          Export QR Code
        </Button>

        <Button
          variant="outlined"
          sx={myQRListStyles.actionButton}
          onClick={() => navigate(`/qrlist/create/${userId}?qr=${qrcode.id}`)}
        >
          Edit
        </Button>
      </Box>
    </Box>
  );
};

export default QRDetails;
